import axios from 'axios'

export default (routeTo, routeFrom, next) => {
  axios
    .post('/api/v2/get_vouchers', { property: routeTo.params.permalink })
    .then(({ data }) => {
      routeTo.params.layout = 'member'
      routeTo.params.vouchers = data

      next()
    })
    .catch(() => {
      next({ name: '404', params: { resource: 'Voucher' } })
    })
}
